import React, { Fragment, useEffect, useCallback } from "react";

const MouseEvents = ({
  setAllowKeyboardShortcuts,
  existsModal,
  focusElement,
  setChatIsFocused,
  onEscPress,
}) => {
  const handleDocumentClick = useCallback(
    (_) => {
      const activeId = document.activeElement.id;
      if (!existsModal) {
        const chatIsFocused = activeId === focusElement;
        setAllowKeyboardShortcuts(!chatIsFocused);
        setChatIsFocused(chatIsFocused);
      }
    },
    [existsModal, focusElement, setAllowKeyboardShortcuts, setChatIsFocused]
  );

  const handleKeydown = useCallback(
    (e) => {
      const code = e.keyCode || e.which;
      if (code === 27) {
        onEscPress(e);
      }
    },
    [onEscPress]
  );

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    document.addEventListener("keydown", handleKeydown);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
      document.removeEventListener("keydown", handleKeydown);
    };
  }, [handleDocumentClick, handleKeydown]);

  return <Fragment />;
};
export default MouseEvents;
